import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

const loader = lazyForPaint(
	() => {
		return import(/* webpackChunkName: "request-create-page-hub-variant" */ './hub-variant');
	},
	{
		ssr: true,
	},
);

export const RequestCreatePageForHubs = withAsync({
	loader,
});
